import { domain } from "../auth/domain";

const authHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Missing session. Please login again.");
  }
  return {
    Authorization: `JWT ${token}`,
    "Content-Type": "application/json",
  };
};

const handleJson = async (response, fallbackMessage) => {
  if (!response.ok) {
    const text = await response.text();
    const message = text || fallbackMessage || "Request failed.";
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }
  return response.json();
};

export const fetchEntryFeeInvoices = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endpoint = query
    ? `${domain}contributions/entry-fee-invoices/?${query}`
    : `${domain}contributions/entry-fee-invoices/`;

  const resp = await fetch(endpoint, {
    method: "GET",
    headers: authHeaders(),
  });

  return handleJson(resp, "Failed to load entry fee invoices.");
};

export const exportEntryFeeInvoices = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endpoint = query
    ? `${domain}contributions/entry-fee-invoices/export/?${query}`
    : `${domain}contributions/entry-fee-invoices/export/`;

  const resp = await fetch(endpoint, {
    method: "GET",
    headers: {
      ...authHeaders(),
      Accept: "text/csv",
    },
  });

  if (!resp.ok) {
    const text = await resp.text();
    const err = new Error(text || "Failed to export invoices.");
    err.status = resp.status;
    throw err;
  }

  const blob = await resp.blob();
  return blob;
};
